/**
 * @module lib/id
 * Tools for aggregating and desconstructing entity IDs.
 */

/*
 * We need escaping so that aggregation can be nested, and so that
 *   IDs which already contain our delimiter don't cause problems.
 */

const DELIMITER = ":";
const REGEX_DELIMITER = "\\:";
const ESCAPE = "~";
const REGEX_ESCAPE = "\\~";

function escapeDelimiter(string) {
  return string
    .toString()
    .replace(new RegExp(REGEX_ESCAPE), ESCAPE + ESCAPE)
    .replace(new RegExp(REGEX_DELIMITER), DELIMITER + ESCAPE);
}

function unescapeDelimiter(string) {
  return string
    .replace(new RegExp(REGEX_ESCAPE + REGEX_ESCAPE), ESCAPE)
    .replace(new RegExp(REGEX_DELIMITER + REGEX_ESCAPE), DELIMITER);
}

/**
 * Combine multiple constituent IDs into a single aggregated ID.
 * @param {...string} constituents
 * @returns {string} aggregated ID
 */
export function aggregateID(...constituents) {
  return constituents.map(escapeDelimiter).join(":");
}

/**
 * Break an aggregated ID down into its constituent parts.
 * @param {string} id aggregated ID
 * @returns {Array<string>} constituents
 */
export function deconstructID(id) {
  const pattern = new RegExp(`${REGEX_DELIMITER}(?!${REGEX_ESCAPE})`);
  return id.split(pattern).map(unescapeDelimiter);
}



// WEBPACK FOOTER //
// ./src/lib/id/index.js